import component from './manageHotels.vue';
export const MANAGE_HOTELS_NOTES = 'manageHotelsNotes';

export default{
    id: MANAGE_HOTELS_NOTES,
    component,
    props: {
        isManagingNotes: true
    }
}